// CompletedPigRunBroadcastCommand.
//
// Class used as a container to encapsulate the completed pig run broadcast command(s).
export class CompletedPigRunBroadcastCommand {
  public commandList: string[];
  public pigRunId: number;

  public constructor(pigRunId: number, commandList: string[]) {
    this.pigRunId = pigRunId;
    this.commandList = commandList;
  }
}
